module.exports = __webpack_public_path__ + "static/media/1009894.c151cd69.jpg";